import { PocketTransfer } from "@components/resolvers/pocket.resolvers";
import axios from "axios";
import {
  BaseService,
  sipondApiToken,
  sipondBaseURL,
  sipondPaymentApiToken,
} from "./base.service";
import { BaseResponse, BaseResponseExternal } from "./dtos/base.dto";
import {
  BillsResponse,
  DormitoryActivitySummaryResponse,
  HistoryBalanceResponse,
  PaymentPocketRequest,
  PocketHistoryResponse,
  PocketResponse,
  VirtualAccountReportResponse,
  VirtualAccountRequest,
  VirtualAccountRequestZiswaf,
  ZiswafResponse,
} from "./dtos/finance.dto";

interface FinanceServiceInterface {
  queries: {
    GET_FINANCE_BILLS: string;
    GET_FINANCE_POCKET: string;
    GET_FINANCE_BILLS_PAID_OF: string;
    GET_FINANCE_CHECKING_ACCOUNT: string;
    GET_FINANCE_POCKET_HISTORY: string;
    GET_FINANCE_VIRTUAL_ACCOUNT_REPORT: string;
    GET_HISRTORY_BALANCE: string;
    GET_FINANCE_CHECKING_ACCOUNT_OLD: string;
    GET_ZISWAF: string;
    GET_DORMITORY_ACTIVITY_SUMMARY: string;
  };
  bills(limit: string): Promise<BillsResponse>;
  billsPaidOf(payload: { nis: string }): Promise<BillsResponse>;
  ziswafList(): Promise<ZiswafResponse>;
  checkingAccount(payload: {
    range: "WEEK" | "MONTH";
    type: "ALL" | "IN" | "OUT";
  }): Promise<PocketHistoryResponse>;
  pocket(): Promise<PocketResponse>;
  pocketTransfer(payload: PocketTransfer): Promise<BaseResponse<number>>;
  pocketHistory(
    pocket: string,
    payload: {
      range: "WEEK" | "MONTH";
      type: "ALL" | "IN" | "OUT";
    },
  ): Promise<PocketHistoryResponse>;
  virtualAccountReport(payload: {
    nis: string;
    limit: "10" | "20" | "50";
    status: "ALL" | "PENDING" | "COMPLETED" | "EXPIRED";
  }): Promise<VirtualAccountReportResponse>;
  virtualAccountCancel(id: string): Promise<BaseResponse>;
  virtualAccountRequest(payload: VirtualAccountRequest): Promise<BaseResponse>;
  virtualAccountRequestZiswaf(
    payload: VirtualAccountRequestZiswaf,
  ): Promise<BaseResponse>;
  paymentWithPocket(payload: PaymentPocketRequest): Promise<BaseResponse>;
  historyBalance(payload: {
    nis: string;
    limit: "10" | "20" | "50";
  }): Promise<HistoryBalanceResponse>;
  checkingAccountOld(payload: {
    nis: string;
    limit: "10" | "20" | "50";
    type: "ALL" | "IN" | "OUT";
  }): Promise<BaseResponse>;
  dormitoryActivitySummary(payload: {
    nis: string;
  }): Promise<DormitoryActivitySummaryResponse>;
}
export const FinanceService: FinanceServiceInterface = {
  queries: {
    GET_FINANCE_BILLS: "GET_FINANCE_BILLS",
    GET_FINANCE_BILLS_PAID_OF: "GET_FINANCE_BILLS_PAID_OF",
    GET_FINANCE_CHECKING_ACCOUNT: "GET_FINANCE_CHECKING_ACCOUNT",
    GET_FINANCE_POCKET: "GET_FINANCE_POCKET",
    GET_FINANCE_POCKET_HISTORY: "GET_FINANCE_POCKET_HISTORY",
    GET_FINANCE_VIRTUAL_ACCOUNT_REPORT: "GET_FINANCE_VIRTUAL_ACCOUNT_REPORT",
    GET_HISRTORY_BALANCE: "GET_HISRTORY_BALANCE",
    GET_FINANCE_CHECKING_ACCOUNT_OLD: "GET_FINANCE_CHECKING_ACCOUNT_OLD",
    GET_ZISWAF: "GET_ZISWAF",
    GET_DORMITORY_ACTIVITY_SUMMARY: "GET_DORMITORY_ACTIVITY_SUMMARY",
  },
  bills: async (limit: string) => {
    try {
      const request = await BaseService.request().get<BillsResponse>(
        "/finance/bills",
        { params: { limit } },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  billsPaidOf: async (payload: { nis: string }) => {
    try {
      const request = await axios.get<BillsResponse>(
        `${sipondBaseURL}/api/keuangan-lama/get-spp`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  ziswafList: async () => {
    try {
      const request = await axios.get<ZiswafResponse>(
        `${sipondBaseURL}/api/keuangan-lama/get-ziswaf`,
        {
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  checkingAccount: async (payload: {
    range: "WEEK" | "MONTH";
    type: "ALL" | "IN" | "OUT";
  }) => {
    try {
      const request = await BaseService.request().get<PocketHistoryResponse>(
        "/finance/checking-account",
        { params: payload },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  pocket: async () => {
    try {
      const request =
        await BaseService.request().get<BillsResponse>("/finance/pocket");
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  pocketTransfer: async (payload: PocketTransfer) => {
    try {
      const request = await BaseService.request().post<BaseResponse<number>>(
        `/finance/pocket/transfer`,
        payload,
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  pocketHistory: async (
    pocket: string,
    payload: {
      range: "WEEK" | "MONTH";
      type: "ALL" | "IN" | "OUT";
    },
  ) => {
    try {
      const request = await BaseService.request().get<BillsResponse>(
        `/finance/pocket/${pocket}/history`,
        { params: payload },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  virtualAccountReport: async (payload: {
    nis: string;
    limit: "10" | "20" | "50";
    status: "ALL" | "PENDING" | "COMPLETED" | "EXPIRED";
  }) => {
    try {
      const request = await axios.get<VirtualAccountReportResponse>(
        `${sipondBaseURL}/api/orangtua/va-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  virtualAccountCancel: async (id: string) => {
    try {
      const request = await BaseService.request().get<BillsResponse>(
        `/finance/virtual-accounts-cancel/${id}`,
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  virtualAccountRequest: async (payload: VirtualAccountRequest) => {
    try {
      const request = await axios.post<
        BaseResponseExternal<{
          trxAmount: number;
          nis: string;
          customerName: string;
          virtualAccount: string;
          datetimeExpired: Date;
          trxID: string;
          jenis: string;
          requestPayment: string;
        }>
      >(`${sipondBaseURL}/api/keuangan-lama/submit-va`, payload, {
        headers: {
          token: sipondPaymentApiToken,
        },
      });
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
  virtualAccountRequestZiswaf: async (payload: VirtualAccountRequestZiswaf) => {
    try {
      const request = await axios.post<BaseResponseExternal>(
        `${sipondBaseURL}/api/tagihan/submit_va_ziswaf`,
        payload,
        {
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: request.data.data,
      };
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
  paymentWithPocket: async (payload: PaymentPocketRequest) => {
    try {
      const request = await axios.post<BaseResponseExternal>(
        `${sipondBaseURL}/api/tagihan/submit_bayar_tagihan`,
        payload,
        {
          headers: {
            token: sipondPaymentApiToken,
          },
        },
      );
      return {
        success: request.data.status,
        message: request.data.message,
        data: null,
      };
    } catch (error: any) {
      throw new Error("Terjadi Kesalahan Server!");
    }
  },
  historyBalance: async (payload: {
    nis: string;
    limit: "10" | "20" | "50";
  }) => {
    try {
      const request = await axios.get<HistoryBalanceResponse>(
        `${sipondBaseURL}/api/orangtua/balance-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  checkingAccountOld: async (payload: {
    nis: string;
    limit: "10" | "20" | "50";
    type: "ALL" | "IN" | "OUT";
  }) => {
    try {
      const request = await axios.get<BaseResponse>(
        `${sipondBaseURL}/api/orangtua/finance-record`,
        {
          params: payload,
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
  dormitoryActivitySummary: async (payload: { nis: string }) => {
    try {
      const request = await axios.get<DormitoryActivitySummaryResponse>(
        `${sipondBaseURL}/api/orangtua/get-kegiatan-asrama/${payload.nis}`,
        {
          headers: {
            token: sipondApiToken,
          },
        },
      );
      return BaseService.response(request);
    } catch (error: any) {
      return BaseService.response(error, true);
    }
  },
};
